import { AdResponse } from '../types/Ad.api.type';

/**
 * 가중치 기반 단일 랜덤 선택 (상세 댓글 광고용)
 * weight가 높을수록 선택 확률이 높아짐
 */
export function weightedRandomSelect(ads: AdResponse[]): AdResponse | undefined {
  if (ads.length === 0) return undefined;
  if (ads.length === 1) return ads[0];

  const totalWeight = ads.reduce((sum, ad) => sum + (ad.weight ?? 1), 0);
  let random = Math.random() * totalWeight;

  for (const ad of ads) {
    random -= ad.weight ?? 1;
    if (random <= 0) return ad;
  }

  return ads[ads.length - 1];
}

/**
 * 가중치 기반 셔플 (피드 광고용)
 * weight가 높을수록 앞쪽에 배치될 확률이 높아짐
 */
export function weightedShuffle(ads: AdResponse[]): AdResponse[] {
  if (ads.length <= 1) return [...ads];

  const remaining = [...ads];
  const result: AdResponse[] = [];

  while (remaining.length > 0) {
    const totalWeight = remaining.reduce((sum, ad) => sum + (ad.weight ?? 1), 0);
    let random = Math.random() * totalWeight;

    for (let i = 0; i < remaining.length; i++) {
      random -= remaining[i].weight ?? 1;
      if (random <= 0) {
        result.push(remaining[i]);
        remaining.splice(i, 1);
        break;
      }
    }

    // 부동소수점 오차 방지
    if (result.length === remaining.length + result.length - remaining.length) continue;
  }

  return result;
}
